import { SharedCurrentUser } from "./types";

export const isShowFloatingRegisterButton = ({
  currentUser,
}: {
  currentUser: SharedCurrentUser;
}) => {
  return currentUser == null;
};
